module.exports = __webpack_public_path__ + "img/icon_sportMenu_badminton.c07390fc.svg";